export default "__VITE_ASSET__6f377ba2__"